export default {
    // Header Section
    "discover_your": "Discover Your",
    "lal_kitab": "Lal Kitab",
    "ancient_remedial_wisdom": "Ancient Remedial Wisdom",
    "lal_kitab_description": "Step into the world of ancient wisdom with a personalized Lal Kitab analysis. Reveal hidden karmic patterns, uncover life’s secrets, and receive simple yet powerful remedies to transform challenges into opportunities for success, harmony, and prosperity.",

    "lal_kitab_title": "with Lal Kitab",
    "craft_your_destiny":"Craft Your Destiny",

    // Service Information
    "enter_details_for_lal_kitab": "Enter Your Details for Lal Kitab Analysis",
    "complete_lal_kitab_analysis": "Complete Lal Kitab Analysis",
    "service_price": "Service Price",
    "comprehensive_lal_kitab_analysis_note": "Detailed Lal Kitab chart analysis with practical remedies and karmic guidance",

    // Form Fields
    "full_name": "Full Name",
    "enter_full_name": "Enter your full name",
    "name_lal_kitab_influence": "Your name influences karmic patterns and remedial effectiveness in Lal Kitab",
    "email_address": "Email Address",
    "enter_email_address": "Enter your email address",
    "phone_number": "Phone Number",
    "enter_phone_number": "Enter your phone number",
    "gender": "Gender",
    "male": "Male",
    "female": "Female",
    "other": "Other",
    "date_of_birth": "Date of Birth",
    "birth_date_lal_kitab_chart": "Essential for creating accurate Lal Kitab chart and planetary analysis",
    "time_of_birth": "Time of Birth",
    "exact_time_lal_kitab_houses": "Precise time needed for accurate house placements in Lal Kitab system",
    "place_of_birth": "Place of Birth",
    "place_of_birth_placeholder": "City, State, Country",
    "location_lal_kitab_analysis": "Location affects planetary positions and Lal Kitab chart calculations",
    "preferred_language": "Preferred Language",
    "english": "English",
    "hindi": "Hindi",
    "telugu": "Telugu",
    "kannada": "Kannada",
    "language_note": "Your Lal Kitab analysis will be delivered in the selected language",

    // Core Lal Kitab Features
    "lal_kitab_chart_analysis": "Lal Kitab Chart Analysis",
    "planetary_positions_lal_kitab": "Planetary Positions in Lal Kitab",
    "practical_remedies_solutions": "Practical Remedies & Solutions",
    "karmic_debts_analysis": "Karmic Debts Analysis",
    "life_predictions_guidance": "Life Predictions & Guidance",
    "pdf_download": "Comprehensive PDF Report",

    "what_you_get": "What Your Lal Kitab Analysis Includes",
    "complete_lal_kitab_chart": "Complete Lal Kitab Chart",
    "practical_remedial_measures": "Practical Remedial Measures",
    "karmic_analysis_guidance": "Karmic Analysis & Guidance",
    "life_predictions_insights": "Life Predictions & Insights",

    // Actions & Buttons
    "pay_and_get_lal_kitab_analysis": "Get My Lal Kitab Analysis",
    "processing_payment": "Processing Payment",
    "processing_request": "Generating Analysis",

    // Payment & Success Messages
    "thank_you": "Thank You",
    "payment_successful": "Payment Successful!",
    "lal_kitab_analysis_processing": "Your comprehensive Lal Kitab analysis is being prepared by our expert Lal Kitab astrologers. You'll receive detailed chart analysis with practical remedies and karmic insights.",
    "order_id": "Order ID",
    "payment_id": "Payment ID",
    "amount_paid": "Amount Paid",

    // Delivery Information
    "delivery_information": "Delivery Information",
    "delivery_time": "Analysis Delivery",
    "within_24_hours_delivery_note": "Your detailed Lal Kitab analysis will be ready within 24 hours",
    "whatsapp_notification": "WhatsApp Updates",
    "whatsapp_delivery_note": "Receive instant notifications on WhatsApp",
    "email_delivery": "Email Delivery",
    "email_delivery_note": "Complete analysis delivered to",

    // What You'll Receive
    "what_youll_receive": "Your Lal Kitab Analysis Package",
    "detailed_lal_kitab_report": "Detailed Lal Kitab Report (PDF)",
    "lal_kitab_chart_analysis": "Lal Kitab Chart Analysis",
    "practical_remedies_list": "Practical Remedies List",
    "karmic_debts_solutions": "Karmic Debts & Solutions",
    "life_guidance_predictions": "Life Guidance & Predictions",

    // Visual Content
    "sample_lal_kitab_analysis": "Sample Lal Kitab Analysis",
    "lal_kitab_house_analysis": "Lal Kitab House Analysis",
    "sample_lal_kitab_reading": "Strong planetary positions with practical remedial solutions",
    "sample_lal_kitab_preview": "Preview of your personalized Lal Kitab analysis with remedial guidance",
    "lal_kitab_houses": "Lal Kitab Houses",

    // House Types
    "self": "Self",
    "wealth": "Wealth",
    "siblings": "Siblings",
    "mother": "Mother",
    "children": "Children",
    "enemies": "Enemies",
    "spouse": "Spouse",
    "longevity": "Longevity",
    "father": "Father",
    "career": "Career",
    "gains": "Gains",
    "expenses": "Expenses",

    // Status & Processing
    "your_lal_kitab_analysis_status": "Your Lal Kitab Analysis Status",
    "processing_your_analysis": "Analyzing Your Lal Kitab Chart",
    "analysis_processing_message": "Our expert Lal Kitab astrologers are studying your birth chart to provide accurate analysis with practical remedies and karmic insights.",
    "request_id": "Analysis ID",
    "status": "Status",
    "processing": "In Progress",
    "pending": "Queued",
    "email_notification_sent": "Confirmation email sent",
    "whatsapp_update_coming": "WhatsApp updates enabled",
    "delivery_within_24_hours": "Report ready within 24 hours",

    // Support & Contact
    "contact_support": "Contact Lal Kitab Support",
    "need_help": "Need guidance?",
    "contact_us_at": "Reach us at",

    // Error Messages
    "please_fill_all_required_fields": "Please complete all required birth details",
    "payment_failed": "Payment unsuccessful. Please try again.",
    "processing_failed": "Analysis processing failed. Contact our support team.",

    // Lal Kitab Specific Elements
    "planetary_debts": "Planetary Debts",
    "karmic_accounts": "Karmic Accounts",
    "ancestral_karma": "Ancestral Karma",
    "past_life_debts": "Past Life Debts",
    "family_karma": "Family Karma",
    "collective_karma": "Collective Karma",

    // Planets in Lal Kitab
    "sun_lal_kitab": "Sun in Lal Kitab",
    "moon_lal_kitab": "Moon in Lal Kitab",
    "mars_lal_kitab": "Mars in Lal Kitab",
    "mercury_lal_kitab": "Mercury in Lal Kitab",
    "jupiter_lal_kitab": "Jupiter in Lal Kitab",
    "venus_lal_kitab": "Venus in Lal Kitab",
    "saturn_lal_kitab": "Saturn in Lal Kitab",
    "rahu_lal_kitab": "Rahu in Lal Kitab",
    "ketu_lal_kitab": "Ketu in Lal Kitab",

    // Remedial Categories
    "simple_remedies": "Simple Home Remedies",
    "donation_remedies": "Donation & Charity Remedies",
    "feeding_remedies": "Feeding & Service Remedies",
    "water_remedies": "Water Related Remedies",
    "clothing_remedies": "Clothing & Color Remedies",
    "behavioral_remedies": "Behavioral Change Remedies",

    // Types of Debts
    "pitra_rin": "Pitra Rin (Ancestral Debt)",
    "matru_rin": "Matru Rin (Mother's Debt)",
    "stree_rin": "Stree Rin (Wife's Debt)",
    "bhratru_rin": "Bhratru Rin (Brother's Debt)",
    "putra_rin": "Putra Rin (Son's Debt)",
    "guru_rin": "Guru Rin (Teacher's Debt)",

    // Lal Kitab Concepts
    "blind_planets": "Blind Planets",
    "lame_planets": "Lame Planets",
    "sleeping_planets": "Sleeping Planets",
    "deceased_planets": "Deceased Planets",
    "enemy_planets": "Enemy Planets",
    "friend_planets": "Friend Planets",

    // House Analysis
    "first_house": "1st House - Personality & Self",
    "second_house": "2nd House - Wealth & Family",
    "third_house": "3rd House - Siblings & Communication",
    "fourth_house": "4th House - Mother & Property",
    "fifth_house": "5th House - Children & Education",
    "sixth_house": "6th House - Enemies & Health",
    "seventh_house": "7th House - Marriage & Partnership",
    "eighth_house": "8th House - Longevity & Occult",
    "ninth_house": "9th House - Father & Fortune",
    "tenth_house": "10th House - Career & Status",
    "eleventh_house": "11th House - Gains & Friends",
    "twelfth_house": "12th House - Expenses & Foreign",

    // Planetary Strengths
    "strong_planets": "Strong Planets",
    "weak_planets": "Weak Planets",
    "malefic_planets": "Malefic Planets",
    "benefic_planets": "Benefic Planets",
    "neutral_planets": "Neutral Planets",
    "exalted_planets": "Exalted Planets",

    // Remedy Types
    "immediate_remedies": "Immediate Effect Remedies",
    "long_term_remedies": "Long-term Remedies",
    "emergency_remedies": "Emergency Remedies",
    "preventive_remedies": "Preventive Remedies",
    "corrective_remedies": "Corrective Remedies",
    "protective_remedies": "Protective Remedies",

    // Life Areas Analysis
    "health_analysis": "Health Analysis",
    "wealth_analysis": "Wealth Analysis",
    "career_analysis": "Career Analysis",
    "marriage_analysis": "Marriage Analysis",
    "children_analysis": "Children Analysis",
    "property_analysis": "Property Analysis",

    // Timing Analysis
    "favorable_periods": "Favorable Periods",
    "challenging_periods": "Challenging Periods",
    "remedy_timing": "Remedy Implementation Timing",
    "result_timing": "Expected Result Timing",
    "life_phases": "Major Life Phases",
    "turning_points": "Life Turning Points",

    // Special Features
    "curse_analysis": "Curse & Negative Energy Analysis",
    "blessing_analysis": "Blessings & Positive Energy",
    "family_tree_karma": "Family Tree Karma Analysis",
    "generational_patterns": "Generational Karma Patterns",
    "soul_purpose": "Soul Purpose & Life Mission",
    "spiritual_evolution": "Spiritual Evolution Path",

    // Practical Applications
    "daily_remedies": "Daily Routine Remedies",
    "weekly_remedies": "Weekly Observances",
    "monthly_remedies": "Monthly Practices",
    "annual_remedies": "Annual Observances",
    "special_occasion_remedies": "Special Occasion Remedies",
    "festival_remedies": "Festival Based Remedies",

    // Modern Adaptations
    "urban_remedies": "Urban Living Adaptations",
    "office_remedies": "Workplace Remedies",
    "travel_remedies": "Travel & Journey Remedies",
    "technology_remedies": "Modern Technology Remedies",
    "social_media_remedies": "Digital Age Remedies",
    "global_living_remedies": "International Living Adaptations",

    // Consultation Features
    "expert_consultation": "Expert Lal Kitab Consultation",
    "follow_up_guidance": "Follow-up Remedy Guidance",
    "progress_tracking": "Remedy Progress Tracking",
    "customization": "Personalized Remedy Customization",
    "update_analysis": "Updated Analysis Options",
    "family_analysis": "Family Chart Analysis",

    // Advanced Concepts
    "paap_planets": "Paap (Sinful) Planets",
    "punya_planets": "Punya (Virtuous) Planets",
    "raja_yoga": "Raja Yoga in Lal Kitab",
    "dhana_yoga": "Dhana Yoga Combinations",
    "vipreet_raja_yoga": "Vipreet Raja Yoga",
    "neech_bhang_yoga": "Neech Bhang Yoga",

    // Unique Lal Kitab Rules
    "pakka_ghar": "Pakka Ghar (Permanent House)",
    "kachha_ghar": "Kachha Ghar (Temporary House)",
    "mool_trikona": "Mool Trikona in Lal Kitab",
    "own_house": "Own House Placement",
    "friendly_house": "Friendly House Position",
    "enemy_house": "Enemy House Placement"
};
